/**
 * GENERATED by W3-01 (src/ui/iconSet.test.ts explains how to refresh it): every lucide icon name, so names can be
 * checked without loading the icons (UX-006). CANONICAL: the icon names; ALIASES: lucide's older names with the
 * icon they stand for (the "...Icon" and "Lucide..." export forms are resolved by stripping that part).
 */

export const CANONICAL: readonly string[] = [
  'AArrowDown',
  'AArrowUp',
  'ALargeSmall',
  'Accessibility',
  'Activity',
  'Ad',
  'AirVent',
  'Airplay',
  'AlarmClock',
  'AlarmClockCheck',
  'AlarmClockMinus',
  'AlarmClockOff',
  'AlarmClockPlus',
  'AlarmSmoke',
  'AlignCenterHorizontal',
  'AlignCenterVertical',
  'AlignEndHorizontal',
  'AlignEndVertical',
  'AlignHorizontalDistributeCenter',
  'AlignHorizontalDistributeEnd',
  'AlignHorizontalDistributeStart',
  'AlignHorizontalJustifyCenter',
  'AlignHorizontalJustifyEnd',
  'AlignHorizontalJustifyStart',
  'AlignHorizontalSpaceAround',
  'AlignHorizontalSpaceBetween',
  'AlignStartHorizontal',
  'AlignStartVertical',
  'AlignVerticalDistributeCenter',
  'AlignVerticalDistributeEnd',
  'AlignVerticalDistributeStart',
  'AlignVerticalJustifyCenter',
  'AlignVerticalJustifyEnd',
  'AlignVerticalJustifyStart',
  'AlignVerticalSpaceAround',
  'AlignVerticalSpaceBetween',
  'Ambulance',
  'Ampersand',
  'Ampersands',
  'Amphora',
  'Anchor',
  'Angle',
  'Antenna',
  'Anvil',
  'Aperture',
  'AppWindow',
  'AppWindowMac',
  'Apple',
  'Archive',
  'ArchiveRestore',
  'ArchiveX',
  'Armchair',
  'ArmenianDram',
  'ArrowBigDown',
  'ArrowBigDownDash',
  'ArrowBigLeft',
  'ArrowBigLeftDash',
  'ArrowBigRight',
  'ArrowBigRightDash',
  'ArrowBigUp',
  'ArrowBigUpDash',
  'ArrowDown',
  'ArrowDown01',
  'ArrowDown10',
  'ArrowDownAZ',
  'ArrowDownFromLine',
  'ArrowDownLeft',
  'ArrowDownNarrowWide',
  'ArrowDownRight',
  'ArrowDownToDot',
  'ArrowDownToLine',
  'ArrowDownUp',
  'ArrowDownWideNarrow',
  'ArrowDownZA',
  'ArrowLeft',
  'ArrowLeftFromLine',
  'ArrowLeftRight',
  'ArrowLeftToLine',
  'ArrowRight',
  'ArrowRightFromLine',
  'ArrowRightLeft',
  'ArrowRightToLine',
  'ArrowUp',
  'ArrowUp01',
  'ArrowUp10',
  'ArrowUpAZ',
  'ArrowUpDown',
  'ArrowUpFromDot',
  'ArrowUpFromLine',
  'ArrowUpLeft',
  'ArrowUpNarrowWide',
  'ArrowUpRight',
  'ArrowUpToLine',
  'ArrowUpWideNarrow',
  'ArrowUpZA',
  'ArrowsUpFromLine',
  'Asterisk',
  'Astroid',
  'AtSign',
  'Atom',
  'AudioLines',
  'AudioLinesOff',
  'AudioLinesX',
  'AudioWaveform',
  'Award',
  'Axe',
  'Axis3d',
  'Baby',
  'Backpack',
  'Badge',
  'BadgeAlert',
  'BadgeCent',
  'BadgeCheck',
  'BadgeDollarSign',
  'BadgeEuro',
  'BadgeIndianRupee',
  'BadgeInfo',
  'BadgeJapaneseYen',
  'BadgeMinus',
  'BadgePercent',
  'BadgePlus',
  'BadgePoundSterling',
  'BadgeQuestionMark',
  'BadgeRussianRuble',
  'BadgeSwissFranc',
  'BadgeTurkishLira',
  'BadgeX',
  'BaggageClaim',
  'Balloon',
  'Ban',
  'Banana',
  'Bandage',
  'BangladeshiTaka',
  'Banknote',
  'BanknoteArrowDown',
  'BanknoteArrowUp',
  'BanknoteCheck',
  'BanknoteX',
  'Barcode',
  'Barrel',
  'Baseline',
  'Bath',
  'Battery',
  'BatteryCharging',
  'BatteryFull',
  'BatteryLow',
  'BatteryMedium',
  'BatteryPlus',
  'BatteryWarning',
  'Beaker',
  'Bean',
  'BeanOff',
  'Bed',
  'BedDouble',
  'BedSingle',
  'Beef',
  'BeefOff',
  'Beer',
  'BeerOff',
  'Bell',
  'BellCheck',
  'BellDot',
  'BellElectric',
  'BellMinus',
  'BellOff',
  'BellPlus',
  'BellRing',
  'BetweenHorizontalEnd',
  'BetweenHorizontalStart',
  'BetweenVerticalEnd',
  'BetweenVerticalStart',
  'BicepsFlexed',
  'Bike',
  'Binary',
  'Binoculars',
  'Biohazard',
  'Bird',
  'Birdhouse',
  'Bitcoin',
  'Blend',
  'Blender',
  'Blinds',
  'Blocks',
  'Bluetooth',
  'BluetoothConnected',
  'BluetoothOff',
  'BluetoothSearching',
  'Bold',
  'Bolt',
  'Bomb',
  'Bone',
  'BoneFracture',
  'Book',
  'BookA',
  'BookAlert',
  'BookAudio',
  'BookBookmark',
  'BookCheck',
  'BookCopy',
  'BookDashed',
  'BookDown',
  'BookHeadphones',
  'BookHeart',
  'BookImage',
  'BookKey',
  'BookLock',
  'BookMinus',
  'BookOpen',
  'BookOpenCheck',
  'BookOpenText',
  'BookPlus',
  'BookSearch',
  'BookText',
  'BookType',
  'BookUp',
  'BookUp2',
  'BookUser',
  'BookX',
  'Bookmark',
  'BookmarkCheck',
  'BookmarkMinus',
  'BookmarkOff',
  'BookmarkPlus',
  'BookmarkX',
  'BoomBox',
  'Bot',
  'BotMessageSquare',
  'BotOff',
  'BottleWine',
  'BowArrow',
  'Box',
  'Boxes',
  'Braces',
  'Brackets',
  'Brain',
  'BrainCircuit',
  'BrainCog',
  'BrickWall',
  'BrickWallFire',
  'BrickWallShield',
  'Bridge',
  'Briefcase',
  'BriefcaseBusiness',
  'BriefcaseConveyorBelt',
  'BriefcaseMedical',
  'BriefcasePlus',
  'BringToFront',
  'Broccoli',
  'Broom',
  'BroomSparkles',
  'Brush',
  'BrushCleaning',
  'Bubbles',
  'Bug',
  'BugOff',
  'BugPlay',
  'Building',
  'BuildingComplex',
  'BuildingComplexPlus',
  'Bus',
  'BusFront',
  'Cable',
  'CableCar',
  'Cake',
  'CakeSlice',
  'Calculator',
  'Calendar',
  'Calendar1',
  'CalendarArrowDown',
  'CalendarArrowUp',
  'CalendarCheck',
  'CalendarCheck2',
  'CalendarChevronsRight',
  'CalendarClock',
  'CalendarCog',
  'CalendarDays',
  'CalendarFold',
  'CalendarHeart',
  'CalendarMinus',
  'CalendarMinus2',
  'CalendarOff',
  'CalendarPlus',
  'CalendarPlus2',
  'CalendarRange',
  'CalendarSearch',
  'CalendarSync',
  'CalendarX',
  'CalendarX2',
  'Calendars',
  'Camera',
  'CameraOff',
  'Can',
  'CanSoda',
  'Candy',
  'CandyCane',
  'CandyOff',
  'Cannabis',
  'CannabisOff',
  'Captions',
  'CaptionsOff',
  'Car',
  'CarBattery',
  'CarFront',
  'CarTaxiFront',
  'Caravan',
  'CardSim',
  'Carrot',
  'Carton',
  'CartonOff',
  'CaseLower',
  'CaseSensitive',
  'CaseUpper',
  'CassetteTape',
  'Cast',
  'Castle',
  'Cat',
  'Cctv',
  'CctvOff',
  'ChartArea',
  'ChartBar',
  'ChartBarBig',
  'ChartBarDecreasing',
  'ChartBarIncreasing',
  'ChartBarStacked',
  'ChartCandlestick',
  'ChartColumn',
  'ChartColumnBig',
  'ChartColumnDecreasing',
  'ChartColumnIncreasing',
  'ChartColumnStacked',
  'ChartGantt',
  'ChartLine',
  'ChartNetwork',
  'ChartNoAxesColumn',
  'ChartNoAxesColumnDecreasing',
  'ChartNoAxesColumnIncreasing',
  'ChartNoAxesCombined',
  'ChartNoAxesGantt',
  'ChartPie',
  'ChartScatter',
  'ChartSpline',
  'Check',
  'CheckCheck',
  'CheckLine',
  'ChefHat',
  'Cherry',
  'ChessBishop',
  'ChessKing',
  'ChessKnight',
  'ChessPawn',
  'ChessQueen',
  'ChessRook',
  'ChevronDown',
  'ChevronFirst',
  'ChevronLast',
  'ChevronLeft',
  'ChevronRight',
  'ChevronUp',
  'ChevronsDown',
  'ChevronsDownUp',
  'ChevronsLeft',
  'ChevronsLeftRight',
  'ChevronsLeftRightEllipsis',
  'ChevronsRight',
  'ChevronsRightLeft',
  'ChevronsUp',
  'ChevronsUpDown',
  'Church',
  'Cigarette',
  'CigaretteOff',
  'Circle',
  'CircleAlert',
  'CircleArrowDown',
  'CircleArrowLeft',
  'CircleArrowOutDownLeft',
  'CircleArrowOutDownRight',
  'CircleArrowOutUpLeft',
  'CircleArrowOutUpRight',
  'CircleArrowRight',
  'CircleArrowUp',
  'CircleCheck',
  'CircleCheckBig',
  'CircleChevronDown',
  'CircleChevronLeft',
  'CircleChevronRight',
  'CircleChevronUp',
  'CircleDashed',
  'CircleDashedCheck',
  'CircleDivide',
  'CircleDollarSign',
  'CircleDot',
  'CircleDotDashed',
  'CircleEllipsis',
  'CircleEqual',
  'CircleEuro',
  'CircleFadingArrowUp',
  'CircleFadingPlus',
  'CircleGauge',
  'CircleMinus',
  'CircleOff',
  'CircleParking',
  'CircleParkingOff',
  'CirclePause',
  'CirclePercent',
  'CirclePile',
  'CirclePlay',
  'CirclePlus',
  'CirclePoundSterling',
  'CirclePower',
  'CircleQuestionMark',
  'CircleSlash',
  'CircleSlash2',
  'CircleSmall',
  'CircleStar',
  'CircleStop',
  'CircleUser',
  'CircleUserRound',
  'CircleX',
  'CircuitBoard',
  'Citrus',
  'Clapperboard',
  'ClefAlto',
  'ClefBass',
  'ClefTreble',
  'Clipboard',
  'ClipboardCheck',
  'ClipboardClock',
  'ClipboardCopy',
  'ClipboardList',
  'ClipboardMinus',
  'ClipboardPaste',
  'ClipboardPen',
  'ClipboardPenLine',
  'ClipboardPlus',
  'ClipboardType',
  'ClipboardX',
  'Clock',
  'Clock1',
  'Clock10',
  'Clock11',
  'Clock12',
  'Clock2',
  'Clock3',
  'Clock4',
  'Clock5',
  'Clock6',
  'Clock7',
  'Clock8',
  'Clock9',
  'ClockAlert',
  'ClockArrowDown',
  'ClockArrowLeft',
  'ClockArrowRight',
  'ClockArrowUp',
  'ClockCheck',
  'ClockFading',
  'ClockPlus',
  'ClosedCaption',
  'Cloud',
  'CloudAlert',
  'CloudBackup',
  'CloudCheck',
  'CloudCog',
  'CloudDownload',
  'CloudDrizzle',
  'CloudFog',
  'CloudHail',
  'CloudLightning',
  'CloudMoon',
  'CloudMoonRain',
  'CloudOff',
  'CloudRain',
  'CloudRainWind',
  'CloudSnow',
  'CloudSun',
  'CloudSunRain',
  'CloudSync',
  'CloudUpload',
  'Cloudy',
  'Clover',
  'Club',
  'Code',
  'CodeXml',
  'Coffee',
  'Cog',
  'Coins',
  'Columns2',
  'Columns3',
  'Columns3Cog',
  'Columns4',
  'Combine',
  'Command',
  'Compass',
  'Component',
  'Computer',
  'ConciergeBell',
  'Cone',
  'Construction',
  'Contact',
  'ContactRound',
  'Container',
  'Contrast',
  'Cookie',
  'CookingPot',
  'Copy',
  'CopyCheck',
  'CopyMinus',
  'CopyPlus',
  'CopySlash',
  'CopyX',
  'Copyleft',
  'Copyright',
  'CornerDownLeft',
  'CornerDownRight',
  'CornerLeftDown',
  'CornerLeftUp',
  'CornerRightDown',
  'CornerRightUp',
  'CornerUpLeft',
  'CornerUpRight',
  'Cpu',
  'CreativeCommons',
  'CreditCard',
  'CreditCardCheck',
  'CreditCardMinus',
  'CreditCardPlus',
  'CreditCardReader',
  'CreditCardX',
  'Croissant',
  'Crop',
  'Cross',
  'Crosshair',
  'Crown',
  'Cuboid',
  'CupSoda',
  'Cupcake',
  'Currency',
  'Cylinder',
  'Dam',
  'Database',
  'DatabaseArrowDown',
  'DatabaseArrowUp',
  'DatabaseBackup',
  'DatabaseCheck',
  'DatabaseMinus',
  'DatabasePlus',
  'DatabaseSearch',
  'DatabaseX',
  'DatabaseZap',
  'DecimalsArrowLeft',
  'DecimalsArrowRight',
  'Delete',
  'Dessert',
  'Diameter',
  'Diamond',
  'DiamondMinus',
  'DiamondPercent',
  'DiamondPlus',
  'Dice1',
  'Dice2',
  'Dice3',
  'Dice4',
  'Dice5',
  'Dice6',
  'Dices',
  'Diff',
  'Disc',
  'Disc2',
  'Disc3',
  'DiscAlbum',
  'Divide',
  'Dna',
  'DnaOff',
  'Dock',
  'Dog',
  'DollarSign',
  'Dome',
  'Donut',
  'DoorClosed',
  'DoorClosedCog',
  'DoorClosedLocked',
  'DoorClosedPackage',
  'DoorOpen',
  'DoorStairwell',
  'Dot',
  'Download',
  'DraftingCompass',
  'Drama',
  'Drill',
  'Drone',
  'Droplet',
  'DropletOff',
  'Droplets',
  'Drum',
  'Drumstick',
  'Dumbbell',
  'Ear',
  'EarOff',
  'Earth',
  'EarthLock',
  'Eclipse',
  'Egg',
  'EggFried',
  'EggOff',
  'Eject',
  'Ellipse',
  'Ellipsis',
  'EllipsisVertical',
  'Engine',
  'Equal',
  'EqualApproximately',
  'EqualApproximatelyNot',
  'EqualNot',
  'Eraser',
  'EthernetPort',
  'Euro',
  'EvCharger',
  'Expand',
  'ExternalLink',
  'Eye',
  'EyeClosed',
  'EyeDashed',
  'EyeOff',
  'FaceAngry',
  'FaceExpressionless',
  'FaceGrinning',
  'FaceNeutral',
  'FaceSlightlyFrowning',
  'FaceSlightlySmiling',
  'FaceSlightlySmilingPlus',
  'Factory',
  'Fan',
  'FastForward',
  'Faucet',
  'Feather',
  'Fence',
  'FerrisWheel',
  'File',
  'FileArchive',
  'FileAxis3d',
  'FileBadge',
  'FileBox',
  'FileBraces',
  'FileBracesCorner',
  'FileChartColumn',
  'FileChartColumnIncreasing',
  'FileChartLine',
  'FileChartPie',
  'FileCheck',
  'FileCheckCorner',
  'FileClock',
  'FileCode',
  'FileCodeCorner',
  'FileCog',
  'FileDiff',
  'FileDigit',
  'FileDown',
  'FileExclamationPoint',
  'FileHeadphone',
  'FileHeart',
  'FileImage',
  'FileInput',
  'FileKey',
  'FileLock',
  'FileMinus',
  'FileMinusCorner',
  'FileMusic',
  'FileOutput',
  'FilePen',
  'FilePenLine',
  'FilePlay',
  'FilePlus',
  'FilePlusCorner',
  'FileQuestionMark',
  'FileScan',
  'FileSearch',
  'FileSearchCorner',
  'FileSignal',
  'FileSliders',
  'FileSpreadsheet',
  'FileStack',
  'FileSymlink',
  'FileTerminal',
  'FileText',
  'FileType',
  'FileTypeCorner',
  'FileUp',
  'FileUser',
  'FileVideoCamera',
  'FileVolume',
  'FileX',
  'FileXCorner',
  'Files',
  'Film',
  'FingerprintPattern',
  'FireExtinguisher',
  'Fish',
  'FishOff',
  'FishSymbol',
  'FishingHook',
  'FishingRod',
  'Flag',
  'FlagOff',
  'FlagTriangleLeft',
  'FlagTriangleRight',
  'Flame',
  'FlameKindling',
  'Flashlight',
  'FlashlightOff',
  'FlaskConical',
  'FlaskConicalOff',
  'FlaskRound',
  'Flower',
  'Flower2',
  'Focus',
  'FoldHorizontal',
  'FoldVertical',
  'Folder',
  'FolderArchive',
  'FolderBookmark',
  'FolderCheck',
  'FolderClock',
  'FolderClosed',
  'FolderCode',
  'FolderCog',
  'FolderDot',
  'FolderDown',
  'FolderGit',
  'FolderGit2',
  'FolderHeart',
  'FolderInput',
  'FolderKanban',
  'FolderKey',
  'FolderLock',
  'FolderMinus',
  'FolderOpen',
  'FolderOpenDot',
  'FolderOutput',
  'FolderPen',
  'FolderPlus',
  'FolderRoot',
  'FolderSearch',
  'FolderSearch2',
  'FolderSymlink',
  'FolderSync',
  'FolderTree',
  'FolderUp',
  'FolderX',
  'Folders',
  'Footprints',
  'Forklift',
  'Form',
  'Forward',
  'Frame',
  'Fuel',
  'Fullscreen',
  'Funnel',
  'FunnelPlus',
  'FunnelX',
  'Galaxy',
  'GalleryHorizontal',
  'GalleryHorizontalEnd',
  'GalleryThumbnails',
  'GalleryVertical',
  'GalleryVerticalEnd',
  'Gamepad',
  'Gamepad2',
  'GamepadDirectional',
  'GapHorizontal',
  'GapVertical',
  'Gauge',
  'Gavel',
  'Gem',
  'GeorgianLari',
  'Germ',
  'GermOff',
  'Ghost',
  'Gift',
  'GitBranch',
  'GitBranchMinus',
  'GitBranchPlus',
  'GitCommitHorizontal',
  'GitCommitVertical',
  'GitCompare',
  'GitCompareArrows',
  'GitFork',
  'GitGraph',
  'GitMerge',
  'GitMergeConflict',
  'GitPullRequest',
  'GitPullRequestArrow',
  'GitPullRequestClosed',
  'GitPullRequestCreate',
  'GitPullRequestCreateArrow',
  'GitPullRequestDraft',
  'GlassWater',
  'Glasses',
  'Globe',
  'GlobeCheck',
  'GlobeCode',
  'GlobeLock',
  'GlobeOff',
  'GlobeX',
  'Goal',
  'Gpu',
  'GraduationCap',
  'Grape',
  'Grid2x2',
  'Grid2x2Check',
  'Grid2x2Plus',
  'Grid2x2X',
  'Grid3x2',
  'Grid3x3',
  'Grip',
  'GripHorizontal',
  'GripVertical',
  'Group',
  'Guitar',
  'Ham',
  'Hamburger',
  'Hammer',
  'Hand',
  'HandCoins',
  'HandFist',
  'HandGrab',
  'HandHeart',
  'HandHelping',
  'HandMetal',
  'HandPlatter',
  'Handbag',
  'Handshake',
  'HardDrive',
  'HardDriveDownload',
  'HardDriveUpload',
  'HardHat',
  'Hash',
  'HatGlasses',
  'Haze',
  'Hd',
  'HdmiPort',
  'Heading',
  'Heading1',
  'Heading2',
  'Heading3',
  'Heading4',
  'Heading5',
  'Heading6',
  'HeadphoneOff',
  'Headphones',
  'Headset',
  'Heart',
  'HeartCrack',
  'HeartHandshake',
  'HeartMinus',
  'HeartOff',
  'HeartPlus',
  'HeartPulse',
  'HeartX',
  'Heater',
  'Helicopter',
  'Hexagon',
  'Highlighter',
  'Hop',
  'HopOff',
  'Hospital',
  'Hotel',
  'Hourglass',
  'HourglassCog',
  'House',
  'HouseCog',
  'HouseHeart',
  'HousePlug',
  'HousePlus',
  'HouseWifi',
  'Houses',
  'IceCreamBowl',
  'IceCreamCone',
  'IdCard',
  'IdCardLanyard',
  'Image',
  'ImageDown',
  'ImageMinus',
  'ImageOff',
  'ImagePlay',
  'ImagePlus',
  'ImageUp',
  'ImageUpscale',
  'Images',
  'Import',
  'Inbox',
  'IndianRupee',
  'Infinity',
  'Info',
  'InspectionPanel',
  'Italic',
  'IterationCcw',
  'IterationCw',
  'IvBag',
  'JapaneseYen',
  'Joystick',
  'Kanban',
  'Kayak',
  'KazakhTenge',
  'Key',
  'KeyRound',
  'KeySquare',
  'Keyboard',
  'KeyboardMusic',
  'KeyboardOff',
  'Lambda',
  'Lamp',
  'LampCeiling',
  'LampDesk',
  'LampFloor',
  'LampWallDown',
  'LampWallUp',
  'LandPlot',
  'Landmark',
  'Languages',
  'Laptop',
  'LaptopMinimal',
  'LaptopMinimalCheck',
  'Lasso',
  'LassoSelect',
  'LayerArrowDown',
  'LayerArrowUp',
  'Layers',
  'Layers2',
  'LayersArrowDown',
  'LayersArrowUp',
  'LayersMinus',
  'LayersPlus',
  'LayoutArrowDown',
  'LayoutArrowRight',
  'LayoutDashboard',
  'LayoutFreeform',
  'LayoutGrid',
  'LayoutGridCircles',
  'LayoutList',
  'LayoutPanelLeft',
  'LayoutPanelTop',
  'LayoutTemplate',
  'Leaf',
  'LeafyGreen',
  'Lectern',
  'LensConcave',
  'LensConvex',
  'Letters',
  'Library',
  'LibraryBig',
  'LifeBuoy',
  'Ligature',
  'Lightbulb',
  'LightbulbOff',
  'Lighthouse',
  'LineDotBottomVertical',
  'LineDotLeftHorizontal',
  'LineDotRightHorizontal',
  'LineDotTopVertical',
  'LineSquiggle',
  'LineStyle',
  'Link',
  'Link2',
  'Link2Off',
  'List',
  'ListCheck',
  'ListChecks',
  'ListChevronsDownUp',
  'ListChevronsUpDown',
  'ListClock',
  'ListCollapse',
  'ListEnd',
  'ListFilter',
  'ListFilterPlus',
  'ListIndentDecrease',
  'ListIndentIncrease',
  'ListMinus',
  'ListMusic',
  'ListOrdered',
  'ListPlus',
  'ListRestart',
  'ListSortAscending',
  'ListSortDescending',
  'ListStart',
  'ListTodo',
  'ListTree',
  'ListVideo',
  'ListX',
  'Loader',
  'LoaderCircle',
  'LoaderPinwheel',
  'Locate',
  'LocateFixed',
  'LocateOff',
  'Lock',
  'LockKeyhole',
  'LockKeyholeOpen',
  'LockOpen',
  'LogIn',
  'LogOut',
  'Logs',
  'Lollipop',
  'Luggage',
  'Magnet',
  'Mail',
  'MailBadge',
  'MailCheck',
  'MailClock',
  'MailMinus',
  'MailOpen',
  'MailPen',
  'MailPlus',
  'MailQuestionMark',
  'MailSearch',
  'MailWarning',
  'MailX',
  'Mailbox',
  'Mails',
  'Map',
  'MapMinus',
  'MapPin',
  'MapPinCheck',
  'MapPinCheckInside',
  'MapPinHouse',
  'MapPinMinus',
  'MapPinMinusInside',
  'MapPinOff',
  'MapPinPen',
  'MapPinPlus',
  'MapPinPlusInside',
  'MapPinSearch',
  'MapPinX',
  'MapPinXInside',
  'MapPinned',
  'MapPlus',
  'Mars',
  'MarsStroke',
  'Martini',
  'Maximize',
  'Maximize2',
  'Medal',
  'Megaphone',
  'MegaphoneOff',
  'MemoryStick',
  'Menu',
  'Merge',
  'MessageCircle',
  'MessageCircleCheck',
  'MessageCircleCode',
  'MessageCircleDashed',
  'MessageCircleDashedCheck',
  'MessageCircleHeart',
  'MessageCircleMore',
  'MessageCircleOff',
  'MessageCirclePlus',
  'MessageCircleQuestionMark',
  'MessageCircleReply',
  'MessageCircleWarning',
  'MessageCircleX',
  'MessageSquare',
  'MessageSquareCheck',
  'MessageSquareCode',
  'MessageSquareDashed',
  'MessageSquareDiff',
  'MessageSquareDot',
  'MessageSquareHeart',
  'MessageSquareLock',
  'MessageSquareMore',
  'MessageSquareOff',
  'MessageSquarePlus',
  'MessageSquareQuote',
  'MessageSquareReply',
  'MessageSquareShare',
  'MessageSquareText',
  'MessageSquareWarning',
  'MessageSquareX',
  'MessagesCircle',
  'MessagesSquare',
  'Metronome',
  'Mic',
  'MicAudioLines',
  'MicOff',
  'MicSignal',
  'MicVocal',
  'Microchip',
  'Microscope',
  'Microwave',
  'MidiPort',
  'Milestone',
  'Milk',
  'MilkOff',
  'Minimize',
  'Minimize2',
  'Minus',
  'MirrorRectangular',
  'MirrorRound',
  'Monitor',
  'MonitorCheck',
  'MonitorCloud',
  'MonitorCog',
  'MonitorDot',
  'MonitorDown',
  'MonitorOff',
  'MonitorPause',
  'MonitorPc',
  'MonitorPlay',
  'MonitorSmartphone',
  'MonitorSpeaker',
  'MonitorStop',
  'MonitorUp',
  'MonitorX',
  'Moon',
  'MoonStar',
  'Mop',
  'MopSparkles',
  'Mosque',
  'Motorbike',
  'Mountain',
  'MountainSnow',
  'Mouse',
  'MouseLeft',
  'MouseOff',
  'MousePointer',
  'MousePointer2',
  'MousePointer2Off',
  'MousePointerBan',
  'MousePointerClick',
  'MouseRight',
  'Mouth',
  'MouthOff',
  'Move',
  'Move3d',
  'MoveDiagonal',
  'MoveDiagonal2',
  'MoveDown',
  'MoveDownLeft',
  'MoveDownRight',
  'MoveHorizontal',
  'MoveLeft',
  'MoveRight',
  'MoveUp',
  'MoveUpLeft',
  'MoveUpRight',
  'MoveVertical',
  'Music',
  'Music2',
  'Music3',
  'Music4',
  'Navigation',
  'Navigation2',
  'Navigation2Off',
  'NavigationOff',
  'NepaliRupee',
  'Network',
  'Newspaper',
  'Nfc',
  'NonBinary',
  'Notebook',
  'NotebookDot',
  'NotebookPen',
  'NotebookTabs',
  'NotebookText',
  'NotepadText',
  'NotepadTextDashed',
  'Nut',
  'NutOff',
  'Octagon',
  'OctagonAlert',
  'OctagonMinus',
  'OctagonPause',
  'OctagonX',
  'Omega',
  'Option',
  'Orbit',
  'Origami',
  'Package',
  'Package2',
  'PackageCheck',
  'PackageMinus',
  'PackageOpen',
  'PackagePlus',
  'PackageSearch',
  'PackageX',
  'PaintBucket',
  'PaintRoller',
  'Paintbrush',
  'PaintbrushVertical',
  'Palette',
  'Panda',
  'PanelBottom',
  'PanelBottomClose',
  'PanelBottomDashed',
  'PanelBottomOpen',
  'PanelLeft',
  'PanelLeftClose',
  'PanelLeftDashed',
  'PanelLeftOpen',
  'PanelLeftRightDashed',
  'PanelRight',
  'PanelRightClose',
  'PanelRightDashed',
  'PanelRightOpen',
  'PanelTop',
  'PanelTopBottomDashed',
  'PanelTopClose',
  'PanelTopDashed',
  'PanelTopOpen',
  'PanelsLeftBottom',
  'PanelsRightBottom',
  'PanelsTopLeft',
  'PaperBag',
  'Paperclip',
  'Parasol',
  'Parentheses',
  'Park',
  'ParkingMeter',
  'PartyPopper',
  'Pause',
  'PawPrint',
  'PcCase',
  'Pen',
  'PenLine',
  'PenOff',
  'PenTool',
  'Pencil',
  'PencilLine',
  'PencilOff',
  'PencilRuler',
  'PencilSparkles',
  'Pentagon',
  'Percent',
  'PersonStanding',
  'Phi',
  'PhilippinePeso',
  'Phone',
  'PhoneCall',
  'PhoneForwarded',
  'PhoneIncoming',
  'PhoneMissed',
  'PhoneOff',
  'PhoneOutgoing',
  'Pi',
  'Piano',
  'Pickaxe',
  'PictureInPicture',
  'PictureInPicture2',
  'PiggyBank',
  'Pilcrow',
  'PilcrowLeft',
  'PilcrowRight',
  'Pill',
  'PillBottle',
  'Pin',
  'PinOff',
  'Pipette',
  'Pizza',
  'Plane',
  'PlaneLanding',
  'PlaneTakeoff',
  'PlantPot',
  'Play',
  'PlayOff',
  'PlayingCard',
  'PlayingCards',
  'PlayingCardsFan',
  'Plug',
  'Plug2',
  'PlugZap',
  'Plus',
  'PocketKnife',
  'Podium',
  'Pointer',
  'PointerOff',
  'Popcorn',
  'Popsicle',
  'PoundSterling',
  'Power',
  'PowerOff',
  'Presentation',
  'Printer',
  'Printer3d',
  'PrinterCheck',
  'PrinterX',
  'Projector',
  'Proportions',
  'Puzzle',
  'Pyramid',
  'QrCode',
  'Quote',
  'Rabbit',
  'Radar',
  'Radiation',
  'Radical',
  'Radio',
  'RadioOff',
  'RadioReceiver',
  'RadioTower',
  'Radius',
  'Rainbow',
  'Rat',
  'Ratio',
  'Receipt',
  'ReceiptCent',
  'ReceiptEuro',
  'ReceiptIndianRupee',
  'ReceiptJapaneseYen',
  'ReceiptPoundSterling',
  'ReceiptRussianRuble',
  'ReceiptSwissFranc',
  'ReceiptText',
  'ReceiptTurkishLira',
  'RectangleCircle',
  'RectangleEllipsis',
  'RectangleGoggles',
  'RectangleHorizontal',
  'RectangleVertical',
  'Recycle',
  'Redo',
  'Redo2',
  'RedoDot',
  'RefreshCcw',
  'RefreshCcwDot',
  'RefreshCw',
  'RefreshCwOff',
  'Refrigerator',
  'Regex',
  'RemoveFormatting',
  'Repeat',
  'Repeat1',
  'Repeat2',
  'RepeatOff',
  'Replace',
  'ReplaceAll',
  'Reply',
  'ReplyAll',
  'Rewind',
  'Ribbon',
  'Road',
  'RobotArm',
  'RobotVacuum',
  'Rocket',
  'RockingChair',
  'RollerCoaster',
  'Rose',
  'Rotate3d',
  'RotateCcw',
  'RotateCcwClock',
  'RotateCcwKey',
  'RotateCcwSquare',
  'RotateCw',
  'RotateCwClock',
  'RotateCwFadingClock',
  'RotateCwSquare',
  'Route',
  'RouteOff',
  'Router',
  'Rows2',
  'Rows3',
  'Rows4',
  'Rss',
  'RugbyBall',
  'Ruler',
  'RulerDimensionLine',
  'RussianRuble',
  'Sailboat',
  'Salad',
  'Sandwich',
  'Satellite',
  'SatelliteDish',
  'SaudiRiyal',
  'Save',
  'SaveAll',
  'SaveCheck',
  'SaveOff',
  'SavePen',
  'SavePlus',
  'Scale',
  'Scale3d',
  'Scaling',
  'Scan',
  'ScanBarcode',
  'ScanBox',
  'ScanEye',
  'ScanFace',
  'ScanHeart',
  'ScanLine',
  'ScanQrCode',
  'ScanSearch',
  'ScanSquare',
  'ScanText',
  'School',
  'Scissors',
  'ScissorsLineDashed',
  'Scooter',
  'ScreenShare',
  'ScreenShareOff',
  'Scroll',
  'ScrollText',
  'Search',
  'SearchAlert',
  'SearchCheck',
  'SearchCode',
  'SearchSlash',
  'SearchX',
  'Section',
  'Send',
  'SendHorizontal',
  'SendToBack',
  'SeparatorHorizontal',
  'SeparatorVertical',
  'Server',
  'ServerCog',
  'ServerCrash',
  'ServerOff',
  'ServerPlus',
  'Settings',
  'Settings2',
  'Shapes',
  'Share',
  'Share2',
  'Sheet',
  'Shell',
  'ShelvingUnit',
  'Shield',
  'ShieldAlert',
  'ShieldBan',
  'ShieldCheck',
  'ShieldCog',
  'ShieldCogCorner',
  'ShieldEllipsis',
  'ShieldHalf',
  'ShieldKeyhole',
  'ShieldLock',
  'ShieldMinus',
  'ShieldOff',
  'ShieldPlus',
  'ShieldQuestionMark',
  'ShieldUser',
  'ShieldX',
  'Ship',
  'ShipCargo',
  'ShipWheel',
  'Shirt',
  'ShoppingBag',
  'ShoppingBasket',
  'ShoppingCart',
  'ShoppingCartMinus',
  'ShoppingCartPlus',
  'Shovel',
  'ShowerHead',
  'Shredder',
  'Shrimp',
  'ShrimpOff',
  'Shrink',
  'Shrub',
  'Shuffle',
  'Sigma',
  'Signal',
  'SignalHigh',
  'SignalLow',
  'SignalMedium',
  'SignalZero',
  'Signature',
  'Signpost',
  'SignpostBig',
  'Siren',
  'SkipBack',
  'SkipForward',
  'Skull',
  'Slash',
  'Slice',
  'SlidersHorizontal',
  'SlidersVertical',
  'Smartphone',
  'SmartphoneCharging',
  'SmartphoneNfc',
  'Snail',
  'Snowflake',
  'SoapDispenserDroplet',
  'Sofa',
  'SolarPanel',
  'Soup',
  'Space',
  'Spade',
  'Sparkle',
  'Sparkles',
  'Speaker',
  'Speech',
  'SpellCheck',
  'SpellCheck2',
  'Spline',
  'SplinePointer',
  'Split',
  'Spool',
  'SportShoe',
  'Spotlight',
  'SprayCan',
  'Sprout',
  'Square',
  'SquareActivity',
  'SquareArrowDown',
  'SquareArrowDownLeft',
  'SquareArrowDownRight',
  'SquareArrowLeft',
  'SquareArrowOutDownLeft',
  'SquareArrowOutDownRight',
  'SquareArrowOutUpLeft',
  'SquareArrowOutUpRight',
  'SquareArrowRight',
  'SquareArrowRightEnter',
  'SquareArrowRightExit',
  'SquareArrowUp',
  'SquareArrowUpLeft',
  'SquareArrowUpRight',
  'SquareAsterisk',
  'SquareBookmark',
  'SquareBottomDashedScissors',
  'SquareCenterlineDashedHorizontal',
  'SquareCenterlineDashedVertical',
  'SquareChartGantt',
  'SquareCheck',
  'SquareCheckBig',
  'SquareChevronDown',
  'SquareChevronLeft',
  'SquareChevronRight',
  'SquareChevronUp',
  'SquareCode',
  'SquareDashed',
  'SquareDashedBottom',
  'SquareDashedBottomCode',
  'SquareDashedKanban',
  'SquareDashedMousePointer',
  'SquareDashedPlus',
  'SquareDashedText',
  'SquareDashedTopSolid',
  'SquareDashedX',
  'SquareDashedXCorner',
  'SquareDimensions',
  'SquareDivide',
  'SquareDot',
  'SquareEqual',
  'SquareExclamationPoint',
  'SquareFunction',
  'SquareKanban',
  'SquareLibrary',
  'SquareM',
  'SquareMenu',
  'SquareMinus',
  'SquareMousePointer',
  'SquareOff',
  'SquareParking',
  'SquareParkingOff',
  'SquarePause',
  'SquarePen',
  'SquarePercent',
  'SquarePi',
  'SquarePilcrow',
  'SquarePlay',
  'SquarePlus',
  'SquarePower',
  'SquareRadical',
  'SquareRoundCorner',
  'SquareScissors',
  'SquareSigma',
  'SquareSlash',
  'SquareSparkles',
  'SquareSplitHorizontal',
  'SquareSplitVertical',
  'SquareSquare',
  'SquareStack',
  'SquareStar',
  'SquareStop',
  'SquareTerminal',
  'SquareText',
  'SquareUser',
  'SquareUserRound',
  'SquareX',
  'SquaresExclude',
  'SquaresIntersect',
  'SquaresSubtract',
  'SquaresUnite',
  'Squircle',
  'SquircleDashed',
  'Squirrel',
  'Stamp',
  'Star',
  'StarCheck',
  'StarHalf',
  'StarMinus',
  'StarOff',
  'StarPlus',
  'StarX',
  'StepBack',
  'StepForward',
  'Stethoscope',
  'Sticker',
  'StickyNote',
  'StickyNoteCheck',
  'StickyNoteMinus',
  'StickyNoteOff',
  'StickyNotePlus',
  'StickyNoteX',
  'StickyNotes',
  'Stone',
  'Store',
  'StretchHorizontal',
  'StretchVertical',
  'Strikethrough',
  'Subscript',
  'Summary',
  'Sun',
  'SunDim',
  'SunMedium',
  'SunMoon',
  'SunSnow',
  'Sunrise',
  'Sunset',
  'Superscript',
  'SwatchBook',
  'SwissFranc',
  'SwitchCamera',
  'Sword',
  'Swords',
  'Syringe',
  'Table',
  'Table2',
  'TableCellsMerge',
  'TableCellsSplit',
  'TableColumnsSplit',
  'TableOfContents',
  'TableProperties',
  'TableRowsSplit',
  'Tablet',
  'TabletSmartphone',
  'Tablets',
  'Tag',
  'TagPlus',
  'TagX',
  'Tags',
  'Tally1',
  'Tally2',
  'Tally3',
  'Tally4',
  'Tally5',
  'Tangent',
  'Target',
  'Telescope',
  'Tent',
  'TentTree',
  'Terminal',
  'TestTube',
  'TestTubeDiagonal',
  'TestTubes',
  'TextAlignCenter',
  'TextAlignEnd',
  'TextAlignJustify',
  'TextAlignJustifyCenter',
  'TextAlignJustifyEnd',
  'TextAlignJustifyStart',
  'TextAlignStart',
  'TextCursor',
  'TextCursorInput',
  'TextInitial',
  'TextQuote',
  'TextSearch',
  'TextWrap',
  'Theater',
  'Thermometer',
  'ThermometerSnowflake',
  'ThermometerSun',
  'ThumbsDown',
  'ThumbsUp',
  'TicTacToe',
  'Ticket',
  'TicketCheck',
  'TicketMinus',
  'TicketPercent',
  'TicketPlus',
  'TicketSlash',
  'TicketX',
  'Tickets',
  'TicketsPlane',
  'Timeline',
  'Timer',
  'TimerOff',
  'TimerReset',
  'ToggleLeft',
  'ToggleRight',
  'Toilet',
  'ToolCase',
  'Toolbox',
  'Toothbrush',
  'ToothbrushSparkles',
  'Tornado',
  'Torus',
  'Touchpad',
  'TouchpadOff',
  'TowelRack',
  'TowerControl',
  'ToyBrick',
  'Tractor',
  'TrafficCone',
  'Trailer',
  'TrainFront',
  'TrainFrontTunnel',
  'TrainTrack',
  'TramFront',
  'Transgender',
  'Trash',
  'TrashOff',
  'TreeDeciduous',
  'TreePalm',
  'TreePine',
  'Trees',
  'TrendingDown',
  'TrendingUp',
  'TrendingUpDown',
  'Triangle',
  'TriangleAlert',
  'TriangleDashed',
  'TriangleRight',
  'TrianglesCenterlineDashedHorizontal',
  'TrianglesCenterlineDashedVertical',
  'Trophy',
  'Truck',
  'TruckElectric',
  'TubeLotion',
  'TurkishLira',
  'Turntable',
  'Turtle',
  'Tv',
  'TvMinimal',
  'TvMinimalPlay',
  'Type',
  'TypeOutline',
  'Umbrella',
  'UmbrellaOff',
  'Underline',
  'Undo',
  'Undo2',
  'UndoDot',
  'UnfoldHorizontal',
  'UnfoldVertical',
  'Ungroup',
  'University',
  'Unlink',
  'Unlink2',
  'Unplug',
  'Upload',
  'Usb',
  'UsbCPort',
  'User',
  'UserCheck',
  'UserCog',
  'UserGroup',
  'UserKey',
  'UserLock',
  'UserMinus',
  'UserPen',
  'UserPlus',
  'UserRound',
  'UserRoundArrowLeft',
  'UserRoundCheck',
  'UserRoundCog',
  'UserRoundGroup',
  'UserRoundKey',
  'UserRoundMinus',
  'UserRoundPen',
  'UserRoundPlus',
  'UserRoundSearch',
  'UserRoundX',
  'UserSearch',
  'UserShield',
  'UserStar',
  'UserX',
  'Users',
  'UsersRound',
  'Utensils',
  'UtensilsCrossed',
  'UtilityPole',
  'Van',
  'Variable',
  'Vault',
  'VectorPolygon',
  'VectorSquare',
  'Vegan',
  'VenetianMask',
  'Venus',
  'VenusAndMars',
  'Vibrate',
  'VibrateOff',
  'Video',
  'VideoOff',
  'Videotape',
  'View',
  'Virus',
  'VirusOff',
  'Voicemail',
  'Volleyball',
  'Volume',
  'Volume1',
  'Volume2',
  'VolumeOff',
  'VolumeX',
  'Vote',
  'Wallet',
  'WalletCards',
  'WalletMinimal',
  'Wallpaper',
  'Wand',
  'WandSparkles',
  'Warehouse',
  'WashingMachine',
  'Watch',
  'WavesArrowDown',
  'WavesArrowUp',
  'WavesHorizontal',
  'WavesLadder',
  'WavesVertical',
  'Waypoints',
  'Webcam',
  'WebcamOff',
  'Webhook',
  'WebhookOff',
  'Weight',
  'WeightTilde',
  'Wheat',
  'WheatOff',
  'Whistle',
  'WholeWord',
  'Wifi',
  'WifiCog',
  'WifiHigh',
  'WifiLow',
  'WifiOff',
  'WifiPen',
  'WifiSync',
  'WifiZero',
  'Wind',
  'WindArrowDown',
  'WindArrowUp',
  'Wine',
  'WineOff',
  'Workflow',
  'Worm',
  'Wrench',
  'WrenchOff',
  'X',
  'XLineTop',
  'Zap',
  'ZapOff',
  'ZodiacAquarius',
  'ZodiacAries',
  'ZodiacCancer',
  'ZodiacCapricorn',
  'ZodiacGemini',
  'ZodiacLeo',
  'ZodiacLibra',
  'ZodiacOphiuchus',
  'ZodiacPisces',
  'ZodiacSagittarius',
  'ZodiacScorpio',
  'ZodiacTaurus',
  'ZodiacVirgo',
  'ZoomIn',
  'ZoomOut',
];

export const ALIASES: Readonly<Record<string, string>> = {
  ActivitySquare: 'SquareActivity',
  AlarmCheck: 'AlarmClockCheck',
  AlarmMinus: 'AlarmClockMinus',
  AlarmPlus: 'AlarmClockPlus',
  Album: 'SquareBookmark',
  AlertCircle: 'CircleAlert',
  AlertOctagon: 'OctagonAlert',
  AlertTriangle: 'TriangleAlert',
  AlignCenter: 'TextAlignCenter',
  AlignJustify: 'TextAlignJustify',
  AlignLeft: 'TextAlignStart',
  AlignRight: 'TextAlignEnd',
  Angry: 'FaceAngry',
  Annoyed: 'FaceExpressionless',
  AreaChart: 'ChartArea',
  ArrowDownAz: 'ArrowDownAZ',
  ArrowDownCircle: 'CircleArrowDown',
  ArrowDownLeftFromCircle: 'CircleArrowOutDownLeft',
  ArrowDownLeftFromSquare: 'SquareArrowOutDownLeft',
  ArrowDownLeftSquare: 'SquareArrowDownLeft',
  ArrowDownRightFromCircle: 'CircleArrowOutDownRight',
  ArrowDownRightFromSquare: 'SquareArrowOutDownRight',
  ArrowDownRightSquare: 'SquareArrowDownRight',
  ArrowDownSquare: 'SquareArrowDown',
  ArrowDownZa: 'ArrowDownZA',
  ArrowLeftCircle: 'CircleArrowLeft',
  ArrowLeftSquare: 'SquareArrowLeft',
  ArrowRightCircle: 'CircleArrowRight',
  ArrowRightSquare: 'SquareArrowRight',
  ArrowUpAz: 'ArrowUpAZ',
  ArrowUpCircle: 'CircleArrowUp',
  ArrowUpLeftFromCircle: 'CircleArrowOutUpLeft',
  ArrowUpLeftFromSquare: 'SquareArrowOutUpLeft',
  ArrowUpLeftSquare: 'SquareArrowUpLeft',
  ArrowUpRightFromCircle: 'CircleArrowOutUpRight',
  ArrowUpRightFromSquare: 'SquareArrowOutUpRight',
  ArrowUpRightSquare: 'SquareArrowUpRight',
  ArrowUpSquare: 'SquareArrowUp',
  ArrowUpZa: 'ArrowUpZA',
  AsteriskSquare: 'SquareAsterisk',
  Axis3D: 'Axis3d',
  BadgeHelp: 'BadgeQuestionMark',
  BarChart: 'ChartNoAxesColumnIncreasing',
  BarChart2: 'ChartNoAxesColumn',
  BarChart3: 'ChartColumn',
  BarChart4: 'ChartColumnIncreasing',
  BarChartBig: 'ChartColumnBig',
  BarChartHorizontal: 'ChartBar',
  BarChartHorizontalBig: 'ChartBarBig',
  BetweenHorizonalEnd: 'BetweenHorizontalEnd',
  BetweenHorizonalStart: 'BetweenHorizontalStart',
  BookMarked: 'BookBookmark',
  BookTemplate: 'BookDashed',
  BoxSelect: 'SquareDashed',
  Building2: 'BuildingComplex',
  CandlestickChart: 'ChartCandlestick',
  CheckCircle: 'CircleCheckBig',
  CheckCircle2: 'CircleCheck',
  CheckSquare: 'SquareCheckBig',
  CheckSquare2: 'SquareCheck',
  ChevronDownCircle: 'CircleChevronDown',
  ChevronDownSquare: 'SquareChevronDown',
  ChevronLeftCircle: 'CircleChevronLeft',
  ChevronLeftSquare: 'SquareChevronLeft',
  ChevronRightCircle: 'CircleChevronRight',
  ChevronRightSquare: 'SquareChevronRight',
  ChevronUpCircle: 'CircleChevronUp',
  ChevronUpSquare: 'SquareChevronUp',
  CircleHelp: 'CircleQuestionMark',
  CircleSlashed: 'CircleSlash2',
  ClipboardEdit: 'ClipboardPen',
  ClipboardSignature: 'ClipboardPenLine',
  Code2: 'CodeXml',
  CodeSquare: 'SquareCode',
  Columns: 'Columns2',
  ColumnsSettings: 'Columns3Cog',
  Contact2: 'ContactRound',
  CurlyBraces: 'Braces',
  DivideCircle: 'CircleDivide',
  DivideSquare: 'SquareDivide',
  DotSquare: 'SquareDot',
  DownloadCloud: 'CloudDownload',
  Edit: 'SquarePen',
  Edit2: 'Pen',
  Edit3: 'PenLine',
  EqualSquare: 'SquareEqual',
  FileAudio: 'FileHeadphone',
  FileAudio2: 'FileHeadphone',
  FileAxis3D: 'FileAxis3d',
  FileBadge2: 'FileBadge',
  FileBarChart: 'FileChartColumnIncreasing',
  FileBarChart2: 'FileChartColumn',
  FileCheck2: 'FileCheckCorner',
  FileCode2: 'FileCodeCorner',
  FileCog2: 'FileCog',
  FileEdit: 'FilePen',
  FileJson: 'FileBraces',
  FileJson2: 'FileBracesCorner',
  FileKey2: 'FileKey',
  FileLineChart: 'FileChartLine',
  FileLock2: 'FileLock',
  FileMinus2: 'FileMinusCorner',
  FilePieChart: 'FileChartPie',
  FilePlus2: 'FilePlusCorner',
  FileQuestion: 'FileQuestionMark',
  FileSearch2: 'FileSearchCorner',
  FileSignature: 'FilePenLine',
  FileType2: 'FileTypeCorner',
  FileVideo: 'FilePlay',
  FileVideo2: 'FileVideoCamera',
  FileVolume2: 'FileSignal',
  FileWarning: 'FileExclamationPoint',
  FileX2: 'FileXCorner',
  Filter: 'Funnel',
  FilterX: 'FunnelX',
  Fingerprint: 'FingerprintPattern',
  FlipHorizontal: 'SquareCenterlineDashedHorizontal',
  FlipHorizontal2: 'TrianglesCenterlineDashedHorizontal',
  FlipVertical: 'SquareCenterlineDashedVertical',
  FlipVertical2: 'TrianglesCenterlineDashedVertical',
  FolderCog2: 'FolderCog',
  FolderEdit: 'FolderPen',
  ForkKnife: 'Utensils',
  ForkKnifeCrossed: 'UtensilsCrossed',
  FormInput: 'RectangleEllipsis',
  Frown: 'FaceSlightlyFrowning',
  FunctionSquare: 'SquareFunction',
  GanttChart: 'ChartNoAxesGantt',
  GanttChartSquare: 'SquareChartGantt',
  GaugeCircle: 'CircleGauge',
  GitCommit: 'GitCommitHorizontal',
  Globe2: 'Earth',
  Grab: 'HandGrab',
  Grid: 'Grid3x3',
  Grid2X2: 'Grid2x2',
  Grid2X2Check: 'Grid2x2Check',
  Grid2X2Plus: 'Grid2x2Plus',
  Grid2X2X: 'Grid2x2X',
  Grid3X3: 'Grid3x3',
  HelpCircle: 'CircleQuestionMark',
  HelpingHand: 'HandHelping',
  History: 'RotateCcwClock',
  Home: 'House',
  IceCream: 'IceCreamCone',
  IceCream2: 'IceCreamBowl',
  Indent: 'ListIndentIncrease',
  IndentDecrease: 'ListIndentDecrease',
  IndentIncrease: 'ListIndentIncrease',
  Inspect: 'SquareMousePointer',
  KanbanSquare: 'SquareKanban',
  KanbanSquareDashed: 'SquareDashedKanban',
  Laptop2: 'LaptopMinimal',
  Laugh: 'FaceGrinning',
  Layers3: 'Layers',
  Layout: 'PanelsTopLeft',
  LetterText: 'TextInitial',
  LibrarySquare: 'SquareLibrary',
  LineChart: 'ChartLine',
  Loader2: 'LoaderCircle',
  LocationEdit: 'MapPinPen',
  MSquare: 'SquareM',
  MailQuestion: 'MailQuestionMark',
  Meh: 'FaceNeutral',
  MenuSquare: 'SquareMenu',
  MessageCircleQuestion: 'MessageCircleQuestionMark',
  Mic2: 'MicVocal',
  MinusCircle: 'CircleMinus',
  MinusSquare: 'SquareMinus',
  MoreHorizontal: 'Ellipsis',
  MoreVertical: 'EllipsisVertical',
  MousePointerSquareDashed: 'SquareDashedMousePointer',
  Move3D: 'Move3d',
  Outdent: 'ListIndentDecrease',
  Paintbrush2: 'PaintbrushVertical',
  Palmtree: 'TreePalm',
  PanelBottomInactive: 'PanelBottomDashed',
  PanelLeftInactive: 'PanelLeftDashed',
  PanelRightInactive: 'PanelRightDashed',
  PanelTopInactive: 'PanelTopDashed',
  PanelsLeftRight: 'Columns3',
  PanelsTopBottom: 'Rows3',
  ParkingCircle: 'CircleParking',
  ParkingCircleOff: 'CircleParkingOff',
  ParkingSquare: 'SquareParking',
  ParkingSquareOff: 'SquareParkingOff',
  PauseCircle: 'CirclePause',
  PauseOctagon: 'OctagonPause',
  PenBox: 'SquarePen',
  PenSquare: 'SquarePen',
  PercentCircle: 'CirclePercent',
  PercentDiamond: 'DiamondPercent',
  PercentSquare: 'SquarePercent',
  PiSquare: 'SquarePi',
  PieChart: 'ChartPie',
  PilcrowSquare: 'SquarePilcrow',
  PlayCircle: 'CirclePlay',
  PlaySquare: 'SquarePlay',
  PlugZap2: 'PlugZap',
  PlusCircle: 'CirclePlus',
  PlusSquare: 'SquarePlus',
  Podcast: 'MicSignal',
  PowerCircle: 'CirclePower',
  PowerSquare: 'SquarePower',
  Rotate3D: 'Rotate3d',
  Rows: 'Rows2',
  Scale3D: 'Scale3d',
  ScatterChart: 'ChartScatter',
  School2: 'University',
  ScissorsSquare: 'SquareScissors',
  ScissorsSquareDashedBottom: 'SquareBottomDashedScissors',
  SendHorizonal: 'SendHorizontal',
  ShieldClose: 'ShieldX',
  ShieldQuestion: 'ShieldQuestionMark',
  Sidebar: 'PanelLeft',
  SidebarClose: 'PanelLeftClose',
  SidebarOpen: 'PanelLeftOpen',
  SigmaSquare: 'SquareSigma',
  SlashSquare: 'SquareSlash',
  Sliders: 'SlidersVertical',
  Smile: 'FaceSlightlySmiling',
  SmilePlus: 'FaceSlightlySmilingPlus',
  SortAsc: 'ArrowUpNarrowWide',
  SortDesc: 'ArrowDownWideNarrow',
  SplitSquareHorizontal: 'SquareSplitHorizontal',
  SplitSquareVertical: 'SquareSplitVertical',
  SquareGanttChart: 'SquareChartGantt',
  Stars: 'Sparkles',
  StopCircle: 'CircleStop',
  Subtitles: 'Captions',
  TableConfig: 'Columns3Cog',
  TerminalSquare: 'SquareTerminal',
  TestTube2: 'TestTubeDiagonal',
  Text: 'TextAlignStart',
  TextSelect: 'SquareDashedText',
  TextSelection: 'SquareDashedText',
  Train: 'TramFront',
  Trash2: 'Trash',
  Tv2: 'TvMinimal',
  Unlock: 'LockOpen',
  UnlockKeyhole: 'LockKeyholeOpen',
  UploadCloud: 'CloudUpload',
  User2: 'UserRound',
  UserCheck2: 'UserRoundCheck',
  UserCircle: 'CircleUser',
  UserCircle2: 'CircleUserRound',
  UserCog2: 'UserRoundCog',
  UserMinus2: 'UserRoundMinus',
  UserPlus2: 'UserRoundPlus',
  UserSquare: 'SquareUser',
  UserSquare2: 'SquareUserRound',
  UserX2: 'UserRoundX',
  Users2: 'UsersRound',
  Verified: 'BadgeCheck',
  Wallet2: 'WalletMinimal',
  Wand2: 'WandSparkles',
  Waves: 'WavesHorizontal',
  WrapText: 'TextWrap',
  XCircle: 'CircleX',
  XOctagon: 'OctagonX',
  XSquare: 'SquareX',
};

/** Icons whose module file name is not the plain kebab-case of their name (loaded one by one on demand). */
export const FILE_EXCEPTIONS: Readonly<Record<string, string>> = {
  ArrowDownAZ: 'arrow-down-a-z',
  ArrowDownZA: 'arrow-down-z-a',
  ArrowUpAZ: 'arrow-up-a-z',
  ArrowUpZA: 'arrow-up-z-a',
  Grid2x2Check: 'grid-2x2-check',
  Grid2x2Plus: 'grid-2x2-plus',
  Grid2x2X: 'grid-2x2-x',
  Grid2x2: 'grid-2x2',
  Grid3x3: 'grid-3x3',
  Grid3x2: 'grid-3x2',
  ArrowDown01: 'arrow-down-0-1',
  ArrowDown10: 'arrow-down-1-0',
  ArrowUp10: 'arrow-up-1-0',
  ArrowUp01: 'arrow-up-0-1',
};
